export default __webpack_public_path__ + "static/media/vehicle.e7162942c698a8a39b5deab27297126f.svg";